/*!
 * Nómada Motopartes — Mobile Menu Rescue v5.4.3
 * ------------------------------------------------
 * Resuelve el bug del menú móvil con skeleton infinito en productos
 * con muchas variantes (caso XTZ 125 con 290 variantes).
 *
 * Causa raíz:
 * El theme Ella en modo `mobile_menu: custom` depende de un flujo de
 * doble click (`window.load → body click → l() → initMultiTabMobile()
 * → body click → i()`). Cuando un producto tiene cientos de variantes,
 * el JS de `<variant-sticky-selects>` y `<variant-radios>` hace muchas
 * operaciones jQuery sobre el DOM al cargar/cambiar variante, y un
 * error en cualquiera de esos scripts (timeout, race condition con
 * Section Rendering API, error en high-variants-patch.js) puede
 * detener la cadena de listeners. Resultado: el botón hamburguesa
 * abre el panel (porque ese listener se atacha primero), pero el
 * skeleton nunca se reemplaza por items reales.
 *
 * Solución:
 * Este script es VANILLA JS PURO (sin dependencias) y actúa
 * independientemente del theme.js. Cuando detecta que el panel del
 * menú móvil tiene .menu_open Y todavía muestra .list-menu-loading,
 * clona el contenido de #HeaderNavigation [data-navigation] (el menú
 * desktop, que SIEMPRE está presente en el DOM) al contenedor móvil.
 *
 * - No depende de jQuery
 * - No depende de theme.js
 * - No depende del setting mobile_menu
 * - No depende de window.load
 * - No depende del flujo de body clicks
 * - Es idempotente (se puede llamar varias veces sin romper nada)
 */
(function () {
  'use strict';

  var RESCUED_FLAG = 'data-nm-menu-rescued';

  function rescueMobileMenu() {
    var mobileContainer = document.querySelector('[data-navigation-mobile]');
    if (!mobileContainer) return false;

    // Ya rescatado: no hacer nada
    if (mobileContainer.getAttribute(RESCUED_FLAG) === 'true') return true;

    // ¿Sigue mostrando skeleton?
    var skeleton = mobileContainer.querySelector('.list-menu-loading');
    if (!skeleton) {
      // El theme.js ya hizo su trabajo, no necesita rescate
      mobileContainer.setAttribute(RESCUED_FLAG, 'true');
      return true;
    }

    // Buscar el menú desktop como fuente
    var desktopNav = document.querySelector('#HeaderNavigation [data-navigation]');
    if (!desktopNav || !desktopNav.innerHTML) {
      // Fallback: buscar cualquier navegación del header
      desktopNav = document.querySelector('#HeaderNavigation .list-menu')
                || document.querySelector('.header__inline-menu .list-menu')
                || document.querySelector('[data-navigation] .list-menu');
      if (!desktopNav) return false;
    }

    // Clonar el menú desktop al panel móvil
    try {
      var nav = document.createElement('nav');
      nav.className = 'header__inline-menu';
      nav.setAttribute('data-navigation', '');
      nav.setAttribute('role', 'navigation');
      nav.innerHTML = desktopNav.innerHTML;

      // Reemplazar skeleton por contenido real
      skeleton.parentNode.removeChild(skeleton);
      mobileContainer.appendChild(nav);
      mobileContainer.setAttribute(RESCUED_FLAG, 'true');

      // Quitar también cualquier otro skeleton hermano
      var siblings = mobileContainer.parentNode
        ? mobileContainer.parentNode.querySelectorAll('.list-menu-loading')
        : [];
      for (var i = 0; i < siblings.length; i++) {
        siblings[i].parentNode.removeChild(siblings[i]);
      }

      // Disparar evento custom para que otros scripts sepan que el menú está listo
      try {
        mobileContainer.dispatchEvent(new CustomEvent('nm:mobile-menu-rescued', { bubbles: true }));
      } catch (e) {}

      return true;
    } catch (err) {
      // Silencioso: si falla, no rompemos nada
      return false;
    }
  }

  function attachRescueTriggers() {
    // 1. Trigger al click del botón hamburguesa
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var toggle = target.closest('.mobileMenu-toggle, [data-mobile-menu], [data-menu-open-sidebar]');
      if (!toggle) return;
      // Intentar varias veces con backoff porque theme.js puede llenar el menú con delay
      setTimeout(rescueMobileMenu, 150);
      setTimeout(rescueMobileMenu, 500);
      setTimeout(rescueMobileMenu, 1200);
    }, true);

    // 2. Trigger cuando el body recibe .menu_open (más confiable que el click directo)
    try {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.attributeName === 'class' && document.body.classList.contains('menu_open')) {
            setTimeout(rescueMobileMenu, 150);
            setTimeout(rescueMobileMenu, 600);
            break;
          }
        }
      });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {
      // MutationObserver no soportado: continuar con click trigger solamente
    }
  }

  function init() {
    attachRescueTriggers();
    // Intento preventivo después de window.load por si el menú ya estaba abierto
    if (document.readyState === 'complete') {
      setTimeout(rescueMobileMenu, 1500);
    } else {
      window.addEventListener('load', function () {
        setTimeout(rescueMobileMenu, 1500);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Exponer para debug manual desde consola
  window.nmRescueMobileMenu = rescueMobileMenu;
})();
